import { NxButtonModule } from "@allianz/ng-aquila/button";
import { NxHeadlineModule } from "@allianz/ng-aquila/headline";
import { NxModalModule } from "@allianz/ng-aquila/modal";
import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-notification",
  templateUrl: "./notification.component.html",
  styleUrls: ["./notification.component.scss"],
  standalone: true,
  imports: [CommonModule, NxModalModule, NxHeadlineModule, NxButtonModule],
})
export class NotificationComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<NotificationComponent>,
    @Inject(MAT_DIALOG_DATA) protected data: any,
  ) {}

  protected closeDialog() {
    this.dialogRef.close();
  }

  protected continue() {
    this.dialogRef.close(true);
  }
}
